/**
 * Pricing Page
 * Standalone page that displays the Paywall/Pricing options
 */

import Paywall from "@/components/Paywall";
import { SEOPresets } from "@/components/SEO";

const Pricing = () => {
  return (
    <div className="min-h-screen bg-background">
      {SEOPresets.pricing}

      {/* Paywall component with openAccess=false to always show pricing */}
      <Paywall
        openAccess={false}
        backUrl="/profile"
        backLabel="Back to Profile"
      >
        {/* Empty children - user will see pricing options */}
        <div />
      </Paywall>
    </div>
  );
};

export default Pricing;
